export const TWO_COLUMNS_CLASS = 'with-two-columns';
export const ONE_COLUMN_CLASS = 'one-column';
